import styled from 'styled-components';
import { PageContent } from '../PageContent/PageContent';
export var StyledPageTitle = /*#__PURE__*/styled(PageContent).withConfig({
  displayName: "StyledPageTitle",
  componentId: "c11n-8-111-1__sc-14zluhz-0"
})([""]);